export default {
  adUnitPath: '/124312541,2820490/Pitchero/ros_mpu1',
  size: [300, 250],
  id: 'ros-top-mpu',
  targeting: {
    Pitchero_Ad_Position: ['ATF'],
    Pitchero_Ad_Size: ['top_mpu'],
  },
};
